var map = {
	"./Abcde": 13208,
	"./Abcde.vue": 13208,
	"./Auth/Login": 63662,
	"./Auth/Login.vue": 63662,
	"./Auth/PasswordEmail": 62033,
	"./Auth/PasswordEmail.vue": 62033,
	"./Auth/PasswordReset": 62052,
	"./Auth/PasswordReset.vue": 62052,
	"./Auth/RegistrationComplete": 3325,
	"./Auth/RegistrationComplete.vue": 3325,
	"./Author": 32973,
	"./Author.vue": 32973,
	"./Authors": 21569,
	"./Authors.vue": 21569,
	"./BasicPage": 87131,
	"./BasicPage.vue": 87131,
	"./Category": 54419,
	"./Category.vue": 54419,
	"./Contact": 94673,
	"./Contact.vue": 94673,
	"./EditorialBoard": 41513,
	"./EditorialBoard.vue": 41513,
	"./Error": 86857,
	"./Error.vue": 86857,
	"./Home": 67318,
	"./Home.vue": 67318,
	"./Post": 58285,
	"./Post.vue": 58285,
	"./ResidentsCorner": 52545,
	"./ResidentsCorner.vue": 52545,
	"./Search": 64669,
	"./Search.vue": 64669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40632;